export default __webpack_public_path__ + "static/media/energy-portfolio.89c04ba4.svg";